// import { FaEye } from "react-icons/fa";
// import { HiOutlineClipboard } from "react-icons/hi2";
// import { PiPhoneCallLight, PiShareFatLight } from "react-icons/pi";
// import { CiCalendar, CiLocationOn, CiMail } from "react-icons/ci";
// import { Link } from "react-router-dom";
// import "./StudentHomeWorkDetails.css";
// import { useEffect, useState } from "react";
// import axios from "axios";

// const StudentHomeWorkDetails = () => {
//   const [studentHW, setStudentHW] = useState([]);
//   const [schoolClassName, setSchoolClassName] = useState("");
//   const [reference, setReference] = useState("");
//   const [allSubjects, setAllSubjects] = useState([]);
//   const [subjectId, setSubjectId] = useState([]);
//   const [studentClass, setStudentClass] = useState();
//   const [teacherProfile, setTeacherProfile] = useState()

//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/classes`)
//       .then((resp) => {
//         const { data } = resp.data;
//         console.log(data);

//         setSchoolClassName(data.slice(0, 8));
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/admin/teachers`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((response) => {
//         console.log(response.data?.data);
//         setTeacherProfile(response.data?.data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, []);



//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/classes/${reference}`)
//       .then((response) => {
//         const { data } = response.data;
//         console.log("data", data);

//         setStudentClass(data.className);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, [reference]);

//   // useEffect(() => {
//   //   axios
//   //     .get(`${API_BASE_URL}/subjects/?reference=${reference}`)
//   //     .then((result) => {
//   //       const { data } = result.data;
//   //       console.log(data);

//   //       setAllSubjects(data);
//   //     })
//   //     .catch((error) => {
//   //       console.log(error);
//   //     });
//   // }, [reference]);

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/admin/homework/requests?classId=${reference}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((response) => {
//         console.log(response.data?.data);
//         const data = response.data?.data;
//         setStudentHW(data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }, [reference]);

//   // console.log(studentClass);

//   const handleReject = async (id) => {
//     try {
//       await axios
//         .post(
//           `${API_BASE_URL}/admin/homework/approve/${id}`,
//           {
//             homeWorkApproval: "reject",
//           },
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         )
//         .then((response) => {
//           console.log(response);
//           alert("You have rejected to assign this student.");
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <div id="home-work-assistance-enquiry-main">
//       <div className="ps-3 pb-3">
//         <h1>
//           <b>Home Work</b>
//         </h1>
//         <div className="d-flex gap-2">
//           <select
//             className="select-dropdown"
//             value={reference}
//             onChange={(e) => setReference(e.target.value)}
//             required
//           >
//             <option value="">-Select Class-</option>
//             {schoolClassName &&
//               schoolClassName.map((classes) => (
//                 <option value={classes._id} key={classes._id}>
//                   {classes?.className}
//                 </option>
//               ))}
//           </select>
//         </div>
//       </div>
//       <div>
//         {studentHW &&
//           studentHW.map((item, idx) => (
//             <div
//               className="home-work-assitance-student-profile-container"
//               key={idx}
//             >
//               <div className="home-work-assitance-student-image-box">
//                 <img
//                   src={require("../../../../Images/student-profile-img.png")}
//                   alt="student-img"
//                 />
//               </div>

//               <div className="home-work-assistance-student-details-box">
//                 <p className="student-name-b">
//                   <b>{item.studentId.fullName}</b>
//                 </p>

//                 <p className="student-phone-and-email">
//                   <span className="student-contact">
//                     <PiPhoneCallLight className="icon-margin" />
//                     {item.studentId.mobile}
//                   </span>
//                   <span className="student-email">
//                     <CiMail className="icon-margin" />
//                     {item.studentId.email}
//                   </span>
//                 </p>
//                 <p className="student-address">
//                   <CiLocationOn className="icon-margin" /> 3rd floor, G-13,
//                   {item.studentId.address} , {item.studentId.city} ,{" "}
//                   {item.studentId.state} - {item.studentId.pinCode}
//                 </p>
//                 <p className="student-class-and-subject">
//                   <span className="student-class">
//                     <HiOutlineClipboard className="icon-margin" />
//                     {studentClass}
//                   </span>
//                   {/* <span className="student-subjects">
//                     <FiServer className="icon-margin" />
//                     Maths, Physics
//                   </span> */}
//                 </p>
//                 <p className="student-class-and-subject">
//                   <span>Home Work Title : </span>
//                   <span>{item.homeWorkTitle}</span>
//                 </p>
//                 <p className="student-class-and-subject">
//                   <span>Language : </span>
//                   <span>{item.language}</span>
//                 </p>
//                 <p className="rejected-accepted-requests-and-forwards">
//                   <span
//                     className="status"
//                     onClick={() => handleReject(item._id)}
//                   >
//                     Reject
//                   </span>
//                   <Link
//                     to={`${API_BASE_URL}/uploads/${item.homeWork}`}
//                     className="view-btn"
//                     target="_blank"
//                   >
//                     <span className="view-btn">
//                       <FaEye
//                         style={{ marginRight: "5px", paddingTop: "2px" }}
//                       />
//                       View
//                     </span>
//                   </Link>
//                   <span className="add-user">
//                     <Link
//                       to={`/home-work-assistance/teacher-assign/${item._id}`}
//                     >
//                       <PiShareFatLight className="share-icon-btn icon-margin" />
//                     </Link>
//                   </span>
//                 </p>
//               </div>
//             </div>
//           ))}
//       </div>
//     </div>
//   );
// };

// export default StudentHomeWorkDetails;





import { FaEye } from "react-icons/fa";
import { HiOutlineClipboard } from "react-icons/hi2";
import { PiPhoneCallLight } from "react-icons/pi";
import { CiLocationOn, CiMail } from "react-icons/ci";
import { useEffect, useState } from "react";
import axios from "axios";
import "./StudentHomeWorkDetails.css";

const StudentHomeWorkDetails = () => {
  const [studentHW, setStudentHW] = useState([]);
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [reference, setReference] = useState("");
  const [studentClass, setStudentClass] = useState("");

  const [teacherProfile, setTeacherProfile] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedHomeworkIds, setSelectedHomeworkIds] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // 📌 GET CLASSES
  useEffect(() => {
    axios.get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        setSchoolClassName(resp.data?.data || []);
      })
      .catch(console.log);
  }, []);

  // 📌 GET TEACHERS
  useEffect(() => {
    axios.get(`${API_BASE_URL}/admin/teachers`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        setTeacherProfile(response.data?.data || []);
        console.log("teacher Data",response.data)
      })
      .catch(console.log);
  }, []);

  // 📌 GET CLASS NAME
  useEffect(() => {
    if (!reference) return;

    axios.get(`${API_BASE_URL}/classes/${reference}`)
      .then((response) => {
        setStudentClass(response.data?.data?.className);
      })
      .catch(console.log);
  }, [reference]);

  // 📌 GET HOMEWORK
  useEffect(() => {
    if (!reference) return;

    axios.get(`${API_BASE_URL}/admin/homework/requests?classId=${reference}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        setStudentHW(response.data?.data || []);
      })
      .catch(console.log);
  }, [reference]);

  // ✅ SELECT STUDENTS
  const handleSelect = (studentId , homeworkid) => {
    if (selectedStudents.includes(studentId)) {
      setSelectedStudents(selectedStudents.filter(id => id !== studentId));
      setSelectedHomeworkIds(selectedHomeworkIds.filter(id => id !== homeworkid))
    } else {
      setSelectedStudents([...selectedStudents, studentId]);
      setSelectedHomeworkIds([...selectedHomeworkIds,homeworkid]);
    }
  };

  // ✅ ASSIGN TEACHER
  const handleAssign = async () => {
    if (!selectedTeacher) {
      alert("Select a teacher");
      return;
    }

    if (selectedStudents.length === 0) {
      alert("Select students");
      return;
    }

    try {
      await axios.post(
        `${API_BASE_URL}/admin/assign-teacher`,
        {
          teacherId: selectedTeacher,
          studentIds: selectedStudents,
          classId: reference,
          selectedHomeworkIds: selectedHomeworkIds
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("Assigned successfully");

      // reset
      setSelectedStudents([]);
      setSelectedTeacher(null);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div id="home-work-assistance-enquiry-main">
      
      {/* HEADER */}
      <div className="ps-3 pb-3">
        <h1><b>Home Work</b></h1>

        <div className="d-flex gap-2">
          <select
            className="select-dropdown"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
          >
            <option value="">-Select Class-</option>
            {schoolClassName.map((cls) => (
              <option key={cls._id} value={cls._id}>
                {cls.className}
              </option>
            ))}
          </select>

          {/* ASSIGN BUTTON */}
          <button className="assign-btn" onClick={handleAssign}>
            Assign Teacher
          </button>
        </div>
      </div>

      {/* 🔥 TEACHER TABS */}
      <div className="teacher-tabs">
        {teacherProfile.map((teacher) => (
          <button
            key={teacher._id}
            className={`teacher-btn ${selectedTeacher === teacher._id ? "active" : ""}`}
            onClick={() => setSelectedTeacher(teacher._id)}
          >
            {teacher.basicInfo.fullName}
          </button>
        ))}
      </div>

      {/* STUDENT HOMEWORK LIST */}
      {studentHW.map((item, idx) => (
        <div className="home-work-assitance-student-profile-container" key={idx}>

          {/* CHECKBOX */}
          <input
            type="checkbox"
            checked={selectedStudents.includes(item.studentId._id)}
            onChange={() => handleSelect(item.studentId._id , item._id)}
          />

          <div className="home-work-assitance-student-image-box">
            <img
              src={require("../../../../Images/student-profile-img.png")}
              alt="student"
            />
          </div>

          <div className="home-work-assistance-student-details-box">
            <p><b>{item.studentId.fullName}</b></p>

            <p>
              <PiPhoneCallLight /> {item.studentId.mobile}
              <CiMail style={{ marginLeft: "10px" }} /> {item.studentId.email}
            </p>

            <p>
              <CiLocationOn /> {item.studentId.address}, {item.studentId.city}
            </p>

            <p>
              <HiOutlineClipboard /> {studentClass}
            </p>

            <p><b>Title:</b> {item.homeWorkTitle}</p>
            <p><b>Language:</b> {item.language}</p>

            <div className="d-flex gap-2 mt-2">
              <a
                href={`${API_BASE_URL}/uploads/${item.homeWork}`}
                target="_blank"
                rel="noreferrer"
                className="view-btn"
              >
                <FaEye /> View
              </a>
            </div>

          </div>
        </div>
      ))}
    </div>
  );
};

export default StudentHomeWorkDetails;